import { ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";

import { darkGradient, lightGradientOpaque } from "./ctaButtonStyles";

export interface FAQCopy {
  header: {
    h2: string;
    h3: string;
  };
  faqs: readonly { readonly q: string; readonly a: string }[];
}

export function FAQ({ copy }: { copy: FAQCopy }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-24 bg-background-light">
      <div className="container mx-auto px-6 md:px-12 max-w-3xl">
        <div className="text-center mb-16">
          <h2 className="text-sm font-semibold bg-clip-text text-transparent uppercase tracking-widest mb-3" style={{ backgroundImage: darkGradient }}>
            {copy.header.h2}
          </h2>
          <h3 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-6">
            {copy.header.h3}
          </h3>
        </div>

        <div className="space-y-4">
          {copy.faqs.map((faq, index) => (
            <div
              key={faq.q}
              className={`border rounded-xl overflow-hidden transition-colors ${openIndex === index ? "border-[#affa67]/80" : "border-gray-200 bg-white hover:border-[#affa67]/80"}`}
              style={{ backgroundImage: openIndex === index ? lightGradientOpaque : "none" }}
            >
              <button
                type="button"
                className="w-full text-left px-6 py-5 flex items-center justify-between focus:outline-none"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="font-medium text-gray-900 pr-8">
                  {faq.q}
                </span>
                {openIndex === index ? (
                  <ChevronUp className="w-5 h-5 text-green-600 flex-shrink-0" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" />
                )}
              </button>

              {openIndex === index && (
                <div className="px-6 pb-5 text-gray-600 leading-relaxed">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
